import loyaltyInclusionFilter from 'lib/offer/loyaltyInclusionFilter'
import { useMemo } from 'react'

export function useLoyaltyInclusions(
  pkgLoyaltyInclusions?: App.PackageInclusion[],
  inclusions?: App.PackageInclusion[],
): App.PackageInclusion[] {
  return useMemo(() => {
    return loyaltyInclusionFilter(pkgLoyaltyInclusions ?? [], inclusions ?? [])
  }, [pkgLoyaltyInclusions, inclusions])
}
